module.exports = __webpack_public_path__ + "static/media/analytics.ef3fa9ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/analytics.svg
// module id = 2189
// module chunks = 0